import React, { useState, useEffect,useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Title,
  DownloadTemplateBtnWrapper,
} from "../../components/styled/DownloadTemplate.styled";
import StyledSelect from "../../components/elements/StyledSelect";
import { Grid } from "@mui/material";
import StyledButton from "../../components/elements/StyledButton";
import Note from "../../components/Note";
import { BiDownload } from "react-icons/bi";
import { HiChevronRight } from "react-icons/hi";
import { toast } from "react-toastify";
import { BackDrop } from "../../components/elements/Loader";
import { getCurrentUserDetails } from "../../services/api/users.api";
import {
  getTemplateById,
  getAllTemplateNames,
} from "../../services/api/models.api";
import { saveAs } from "file-saver";
import { downloadFile } from "../../services/api/fileUpload";
import {getAllCountries} from "../../services/api/country.api";

export default function DownloadTemplate({
  onNext,
  country,
  setCountry,
  model,
  setModel,
  modelV,
  setModelV,
  setModelId,
  selectedModelData,
  setSelectedModelData,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [modelOptions, setModelOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [modelsWithIds, setModelsWithIds] = useState([]);
  const [modelVersionOptions, setModelVersionOptions] = useState([]);
  const [fileSelected, setfileSelected] = useState(false);
  const [countries,setCountries] = useState([]);
  const navigate = useNavigate();

  const handleDownloadTemplate = async () => {
    try {
      const downloadURL = await downloadFile({
        name: encodeURI(selectedModelData.url),
      });
      saveAs(downloadURL, "template.xlsx");
    } catch (err) {
      toast.error("Failed to download template", { theme: "colored" });
    }
  };

  useEffect(()=>{
    const getCountries = async()=>{
      try{
        let response = await getAllCountries();
        setCountries(response);
      }catch(err){
        console.log(err);
        toast.error(err.message, { theme: "colored" });
      }
    }
    getCountries();
    // eslint-disable-next-line
  },[]);

  useEffect(() => {
    if(selectedModelData){
      let relevantCountries = [];
      countries.forEach((item) => {
        let isExist = false;
        selectedModelData.countries.forEach(({ country }) => {
          if (item.label === country) {
            isExist = true;
          }
        });
        if (isExist) {
          relevantCountries.push(item);
        }
      });
      let selectedCountry = selectedModelData.countries.filter((item) => {
        return item.country === country;
      });
      if (selectedCountry && selectedCountry.length > 0) {
        setModelVersionOptions([...selectedCountry[0].versions]);
      }
      relevantCountries.sort((a, b) => a.label.localeCompare(b.label));
      setCountryOptions([...relevantCountries]);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        setIsLoading(true);
        const userDetails = await getCurrentUserDetails();
        if (
          userDetails.user_role === "admin" ||
          userDetails.user_role === "super_admin"
        ) {
          try {
            const allModels = await getAllTemplateNames();
            let formattedModelOptions = allModels.map(({ name }) => name);
            formattedModelOptions.sort();
            setModelOptions([...formattedModelOptions]);
            let formattedModelsWithIds = allModels.map(({ _id, name }) => {
              return { template_id: _id, name };
            });
            setModelsWithIds([...formattedModelsWithIds]);
          } catch (err) {}
        } else {
          let modelsWithPermissions = userDetails.templates.map(({ name }) => {
            return name;
          });
          setModelsWithIds([...userDetails.templates]);
          modelsWithPermissions.sort();
          setModelOptions([...modelsWithPermissions]);
        }
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        if (err.message === "No active account") {
          toast.error("Session Expired, Please Log back", {
            theme: "colored",
          });
          return navigate("/");
        }
      }
    };
    getCurrentUser();
  }, [navigate]);

  const clickNext = () => {
    if (model === "init" || country === "init" || modelV === "init") {
      return toast.error("Please select module, country & version", {
        theme: "colored",
      });
    }
    onNext();
  };

  useEffect(() => {
    if (model !== "init" && country !== "init" && modelV !== "init")
      return setfileSelected(true);
  }, [model, country, modelV]);

  const onChangeModel = async (model) => {
    setModel(model);
    setCountry("init");
    setModelV("init");
    let selectedTemplate = modelsWithIds.filter((item) => {
      return item.name === model;
    });
    try {
      setIsLoading(true);
      let selectedModel = await getTemplateById(
        selectedTemplate[0].template_id
      );
      let relevantCountries = [];
      countries.forEach((item) => {
        let isExist = false;
        selectedModel.countries.forEach(({ country }) => {
          if (item.label === country) {
            isExist = true;
          }
        });
        if (isExist) {
          relevantCountries.push(item);
        }
      });
      setSelectedModelData(selectedModel);
      setModelId(selectedModel._id);
      relevantCountries.sort((a, b) => a.label.localeCompare(b.label));
      setCountryOptions([...relevantCountries]);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const onChangeCountry = async (country) => {
    setCountry(country);
    setModelV("init");
    let selectedCountry = selectedModelData.countries.filter((item) => {
      return item.country === country;
    });
    if (selectedCountry && selectedCountry.length > 0) {
      setModelVersionOptions([...selectedCountry[0].versions]);
    }
  };

  return (
    <div>
      <Title>Download Document</Title>
      {isLoading ? (
        <BackDrop />
      ) : (
        <>
          <Grid
            container
            spacing={2}
            alignItems={"center"}
            justifyContent={"space-between"}
            align={"right"}
          >
            <Grid item xs={12} md={3}>
              <StyledSelect
                label={"Module"}
                defaultVal={"Select the Module"}
                options={modelOptions}
                control={model}
                setControl={(model) => {
                  onChangeModel(model);
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <StyledSelect
                label={"Country"}
                defaultVal={"Select the Country"}
                options={countryOptions}
                control={country}
                setControl={(country) => {
                  onChangeCountry(country);
                }}
                disabled={model === "init" || model === null ? true : false}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <StyledSelect
                label={"Module Version"}
                defaultVal={"Select the Module Version"}
                options={modelVersionOptions}
                control={modelV}
                setControl={setModelV}
                disabled={country === "init" || country === null ? true : false}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Grid item xs={12} md={9} lg={10}>
              {selectedModelData && modelV !== "init" && (
                <Note
                  fileSelected={fileSelected}
                  onClick={handleDownloadTemplate}
                  fileName={selectedModelData.name + ".xlsx"}
                  headers={selectedModelData.headers}
                />
              )}
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              lg={2}
              container
              direction={"column"}
              alignItems={"flex-end"}
            >
              <StyledButton
                variant={"contained"}
                iconRight={<HiChevronRight />}
                onClick={clickNext}
              >
                Next
              </StyledButton>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}
